import Button from 'components/atoms/Button/Button';
import Card from 'components/atoms/Card/Card';
import Heading from 'components/atoms/Heading/Heading';
import Txt from 'components/atoms/Txt/Txt';
import usePanelConfiguration from 'hooks/usePanelConfiguration';
import Lottie from 'lottie-react';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import { RegisterSuccessQuery } from './__generated__/RegisterSuccessQuery.graphql';
import completeAnimation from './assets/completeAnimation.json';
import classes from './RegisterSuccess.module.scss';
import registrationPixels from './registrationPixels';

const query = graphql`
  query RegisterSuccessQuery {
    signupSurveyUrl
  }
`;

const RegisterSuccess: React.FC = () => {
  const router = useRouter();
  const panelConfiguration = usePanelConfiguration();
  const country = panelConfiguration?.country as string;

  const pixelElements = useMemo(
    () =>
      registrationPixels[country]
        ? registrationPixels[country].map((item) => {
            if (item.language === undefined || item.language === router.locale) {
              return <div key={item.network} dangerouslySetInnerHTML={{ __html: item.value }} />;
            }
          })
        : null,
    [country, router.locale],
  );

  const data = useLazyLoadQuery<RegisterSuccessQuery>(
    query,
    {},
    {
      fetchPolicy: 'store-or-network',
    },
  );

  return (
    <div className={classes.wrapper}>
      <Card className={classes.root}>
        <Heading level={2}>Welcome Onboard</Heading>
        <Lottie
          animationData={completeAnimation}
          loop={false}
          style={{ width: '75px', height: '75px', marginBottom: '20px' }}
        />
        <Txt>Your account is now set up</Txt>
        <div className={classes.buttons}>
          <Button
            className={classes.button}
            buttonType="primary"
            buttonSize="large"
            onClick={() => {
              if (data.signupSurveyUrl) {
                window.location.href = data.signupSurveyUrl;
              } else {
                router.push('/dashboard', undefined, { shallow: true });
              }
            }}
          >
            <Txt>Let&apos;s continue</Txt>
          </Button>
        </div>
      </Card>
      {pixelElements}
    </div>
  );
};

export default RegisterSuccess;
